import { Partners } from '@shared/lib/partner'

const homeLink = {
  label: 'Главная',
  href: '/',
}

const steamLink = {
  label: 'Steam',
  href: '/steam',
}

const gamesLink = {
  label: 'Донаты',
  href: '/games',
}

const keysLink = {
  label: 'Ключи',
  href: '/keys',
}

const servicesLink = {
  label: 'Сервисы',
  href: '/services',
}

const newsLink = {
  label: 'Новости',
  href: '/news',
}

export const getInternalLinksByPartner = (partner: Partners) => {
  switch (partner) {
    case Partners.DEFAULT:
      return [homeLink, steamLink, gamesLink, keysLink, servicesLink, newsLink]
    default:
      return [homeLink, steamLink, gamesLink, keysLink, servicesLink]
  }
}

export const ecosystemLinks = [
  {
    label: 'Нейросети',
    href: 'https://payment.mts.ru/tools',
  },
  {
    label: 'Для дизайна',
    href: 'https://payment.mts.ru/tools',
  },
  {
    label: 'Интернет в поездках',
    href: 'https://payment.mts.ru/esim',
  },
]
